import { map } from 'lodash'
import { ItemData } from '../apis/item.api'
import { ItemMaterialInputData } from '../partials/ItemMaterialInput'

export default {
  payloadData (materials: ItemMaterialInputData[]) {
    return map(materials, material => {
      const { item, quantity } = material
      return { material: item.id, quantity: Number(quantity) }
    })
  },

  itemMaterialsTableData (materials: ItemData[], caseQuantity: number) {
    return map(materials, item => {
      const requiredQuantity = caseQuantity * item.material.quantity
      const delta = item.stockQuantity - requiredQuantity
      return { ...item, requiredQuantity, delta }
    })
  }
}
